export enum NavCategoryId {

  HOME              = 'home', // My Zone
  RESULTS           = 'results',
  REPORTS           = 'reports',
  USERS             = 'users',
  NOTIFICATIONS     = 'notifications',
  ADMIN             = 'admin',
  HELP              = 'help',
  TRAINING          = 'training',
}
